export const list = [
  { id: "opthomology", label: "Ophthalmology", subLink: "smileProSurgery" },
  { id: "gyno", label: "Gynaecology", subLink: "childBirth" },

  { id: "pediatrics", label: "Pediatrics", subLink: "generalPaediatrics" },

  {
    id: "internalMedicine",
    label: "Internal Medicine",
    subLink: "jointReplacement",
  },
  {
    id: "diabetology",
    label: "Diabetology",
  },
  { id: "ortho", label: "Orthopedics" },

  {
    id: "generalSurgery",
    label: "General Surgery and Laparoscopic",
  },
  {
    id: "ent",
    label: "ENT",
  },
  {
    id: "cardiology",
    label: "Cardiology",
  },
  {
    id: "nephrology",
    label: "Nephrology",
  },
  {
    id: "neurology",
    label: "Neurology",
  },
  {
    id: "dermatology",
    label: "Dermatology",
  },
  {
    id: "physiotherapy",
    label: "Physiotherapy",
  },

  {
    id: "gastroenterology",
    label: "Gastroenterology",
  },

  {
    id: "radiology",
    label: "Radiology",
  },

  {
    id: "criticalCare",
    label: "Critical Care",
  },
];
